import { Utils } from 'choerodon-ui/dataset';
const getNearStepValues = Utils.getNearStepValues;
const MAX_SAFE_INTEGER = Utils.MAX_SAFE_INTEGER;
const MIN_SAFE_INTEGER = Utils.MIN_SAFE_INTEGER;
const parseNumber = Utils.parseNumber;
const parseBigNumber = Utils.parseBigNumber;
export { MAX_SAFE_INTEGER, MIN_SAFE_INTEGER, getNearStepValues, parseNumber, parseBigNumber, };
